<div class="container">
  <ul class="list-group list-group-flush">
    <a class="list-group-item">
      <span style="font-size: 15px; color: #800000" (click)="loadSubFolders()"
        ><i class="fa fa-folder-open"></i
        ><a
          class="ml-2"
          style="cursor: pointer; color: #495057; font-size: 13px"
          (click)="folderDetails(mainfolder)"
          >{{ mainfolder.name }}</a
        >
      </span>
    </a>
    <a>
      <div *ngIf="showSubfolder">
        <app-document-folder-menu
          *ngFor="let mainfolder of mainFolderSubFolders"
          [mainfolder]="mainfolder"
        >
        </app-document-folder-menu>
      </div>
    </a>
  </ul>
</div>
